<button
  type="button"
  class="form-switch"
  role="switch"
  [class.form-switch--checked]="checked"
  [attr.aria-checked]="checked"
  [attr.aria-label]="ariaLabel()"
  [disabled]="disabled"
  (click)="toggle()"
>
  <span class="form-switch__text">
    @if (helperLabel()) {
      <span class="form-switch__helper">{{ helperLabel() }}</span>
    }

    <span class="form-switch__status">{{ statusLabel }}</span>
  </span>

  <span class="form-switch__track" aria-hidden="true">
    <span class="form-switch__thumb"></span>
  </span>
</button>
